import { render, staticRenderFns } from "./wyhdet.vue?vue&type=template&id=052b721f&scoped=true&"
import script from "./wyhdet.vue?vue&type=script&lang=js&"
export * from "./wyhdet.vue?vue&type=script&lang=js&"
import style0 from "./wyhdet.vue?vue&type=style&index=0&id=052b721f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b721f",
  null
  
)

export default component.exports